import { render, staticRenderFns } from "./updatePrivateBookingForm.vue?vue&type=template&id=490af5c6&lang=pug"
import script from "./updatePrivateBookingForm.vue?vue&type=script&lang=js"
export * from "./updatePrivateBookingForm.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import style1 from "./updatePrivateBookingForm.vue?vue&type=style&index=1&id=490af5c6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('490af5c6')) {
      api.createRecord('490af5c6', component.options)
    } else {
      api.reload('490af5c6', component.options)
    }
    module.hot.accept("./updatePrivateBookingForm.vue?vue&type=template&id=490af5c6&lang=pug", function () {
      api.rerender('490af5c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/privateBookingClassRecordModal/updatePrivateBookingForm.vue"
export default component.exports